export default "__VITE_ASSET__BFkEW0ZI__"